var React = require('react');

function Down (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"fill":"none","stroke":"#FFFFFF","strokeWidth":"6","points":"10,5.911 27.5,25.676 45,5.911 ","key":0}),React.createElement("path",{"fill":"none","stroke":"#FFFFFF","strokeWidth":"6","d":"M26.439,22.955","key":1})]);
}

Down.defaultProps = {"version":"1.0","id":"Layer_1","x":"0px","y":"0px","width":"55px","height":"33.167px","viewBox":"0 0 55 33.167","enableBackground":"new 0 0 55 33.167","xmlSpace":"preserve"};

module.exports = Down;

Down.default = Down;



// WEBPACK FOOTER //
// ./src/components/PrevSlide/down.svg